function customProduct(){
    $('.products:not(#productsTop) .product').each(function() {
        var product = $(this);
        if($(this).find('.flag-discount').length){
            $(this).find('.prices').prepend($(this).find('.price-standard').clone())
            $(this).find('.prices').append($(this).find('.price-save').clone())
        }
        if($(this).find('.availability').length){
           if($(this).find('.availability').text().trim() === 'Na dotaz' || $(this).find('.availability').text().trim() === 'Na otázku'){
            $(this).find('.prices>*').hide();
           }
            
        }
    });
}
    

$(document).ready(function(){
    customProduct();
});
    
document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    customProduct();
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    customProduct();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    customProduct();
});